import { changePlatforms } from 'actions/import';
import React from 'react';
import { useDispatch } from 'react-redux';
import { getImportPlatforms } from 'selectors/import';
import { useSelector } from 'store';
import ImportScanAttachments from './ImportScanAttachments';

const platformsOptions = [
  {
    value: 'outlook',
    label: 'Microsoft O365',
  },
  {
    value: 'teams',
    label: 'Microsoft Teams',
  },
  {
    value: 'gmail',
    label: 'Gmail',
  },
  /* {
    value: 'other',
    label: 'Other',
  }, */
];

const ImportPlatformSelection: React.FC = () => {
  const dispatch = useDispatch();

  const platforms = useSelector(getImportPlatforms);

  const handlePlatformChange = (value: string): void => {
    if (platforms.includes(value)) {
      dispatch(changePlatforms(platforms.filter((pl) => pl !== value)));
    } else {
      dispatch(changePlatforms([...platforms, value]));
    }
  };

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col gap-2 bg-white">
        <div className="flex flex-row">
          <span>Platforms, select all the permissions needed</span>
          <span className="litlingo-red-color">*</span>{' '}
        </div>
        <div className="flex flex-col gap-2">
          {platformsOptions.map((p) => (
            <label
              htmlFor={`${p.value}-checkbox`}
              className="inline-flex flex-row  gap-2 text-body items-center"
              key={p.value}
            >
              <input
                id={`${p.value}-checkbox`}
                type="checkbox"
                name={p.value}
                className="form-checkbox litlingo-checkbox h-4 w-4 transition duration-150 ease-in-out"
                onChange={(): void => handlePlatformChange(p.value)}
                checked={platforms.includes(p.value)}
              />
              <div className="flex flex-row gap-1 text-body">{p.label}</div>
            </label>
          ))}
        </div>
      </div>
      <ImportScanAttachments />
    </div>
  );
};

export default ImportPlatformSelection;
